import type { Theme } from '@cloudscape-design/components/theming';

/**
 * Deloitte brand theme for Cloudscape, applied once at shell startup via
 * `applyTheme()`. Colors/type follow the firm's "Together makes progress"
 * (June 2025) brand platform — see the `deloitte-brand` skill for the full
 * spec this is derived from.
 *
 * `referenceTokens.color.primary` drives Cloudscape's seed-based palette
 * generator: it derives a full light/dark-safe palette (buttons, links,
 * focus rings, interactive text) from one brand color instead of us hand-
 * tuning dozens of individual color tokens per mode.
 */
export const deloitteTheme: Theme = {
  tokens: {
    fontFamilyBase: '"Open Sans", -apple-system, "Helvetica Neue", Roboto, Arial, sans-serif',
  },
  referenceTokens: {
    color: {
      // Deloitte Green — primary brand color.
      primary: '#86BC25',
    },
  },
};
